// extracted by mini-css-extract-plugin
export default {"section":"Pb","isInverse":"Qb","heading":"Rb","isSubtle":"Sb","isImpact":"Tb","lead":"Ub","blinking":"Vb","gradientShift":"Wb","float":"Xb","move":"Yb","scroll":"Zb"};